<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/returnstock/list'

export default {
  name: "returnstock",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>